var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-comment-history"
  }, [_vm.isLoading['commentHistory'] ? _c('span', [_c('span', [_vm._v(" Bezig met ophalen van notities… ")]), _c('FontAwesomeIcon', {
    staticClass: "ml-1",
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : !_vm.commentHistory.length ? _c('span', [_vm._v(" Geen notities. ")]) : _c('BTable', {
    attrs: {
      "items": _vm.commentHistory,
      "fields": _vm.commentHistoryFields,
      "sort-by": "created_at",
      "sort-desc": _vm.sortingOptions.sortDesc
    },
    scopedSlots: _vm._u([{
      key: "table-colgroup",
      fn: function (scope) {
        return [_c('col', {
          staticStyle: {
            "width": "10rem"
          }
        }), _c('col'), _c('col', {
          staticStyle: {
            "min-width": "16rem"
          }
        })];
      }
    }, {
      key: "cell(created_at)",
      fn: function (data) {
        return [data.value ? _c('span', [_vm._v(" " + _vm._s(_vm._f("datetime")(data.value)) + " "), data.item.is_edited ? _c('small', [_c('font-awesome-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: `Bewerkt op ${_vm.DateHelper.datetime(data.item.updated_at)}`,
            expression: "`Bewerkt op ${DateHelper.datetime(data.item.updated_at)}`"
          }],
          staticClass: "text-secondary ml-1 opacity-7",
          attrs: {
            "icon": "info"
          }
        })], 1) : _vm._e()]) : _c('span', [_vm._v("onbekend")])];
      }
    }, {
      key: "cell(comment)",
      fn: function (data) {
        return [data.item.is_editable ? _c('div', {
          staticClass: "float-right"
        }, [_c('b-button', {
          staticClass: "p-0 pr-1",
          attrs: {
            "size": "sm",
            "variant": "link"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('edit', data.item);
            }
          }
        }, [_c('font-awesome-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: `Notitie bewerken`,
            expression: "`Notitie bewerken`"
          }],
          staticClass: "text-info",
          attrs: {
            "icon": "pencil",
            "size": "sm"
          }
        })], 1)], 1) : _vm._e(), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.newLineToBr(data.value))
          }
        })];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }